import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { constant } from 'app/app.constants';
import { ParentService } from 'app/pages/A2-utils/ParentClass/ParentService';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import {
  IEmailRequest,
  IInvoiceFilter,
  IPayorInvoice,
  IPayorInvoiceCompany,
  IPayors,
  IProfitAndPayorResponse,
  IProviders,
  IStatusInvoices
} from '../interfaces/invoice-external.interface';


import { ActionImportsBatchEnum, ActionPayorAndProfitEnum, ActionSendEmailInvoiceEnum } from '../enums/PayorInvoice.enum';

@Injectable()
export class InvoicesExternalService extends ParentService {
  private readonly loadGridDocument = new BehaviorSubject<boolean>(false);
  $loadGridDocument = this.loadGridDocument.asObservable();

  private readonly isCloseModalBatch = new BehaviorSubject<{ action: ActionImportsBatchEnum, isClose: boolean, comparer: boolean }>
    ({ action: null, isClose: false, comparer: false });
  $isCloseModalBatch = this.isCloseModalBatch.asObservable();


  private readonly isCloseModalFile = new BehaviorSubject<boolean>(false);
  $isCloseModalFile = this.isCloseModalFile.asObservable();


  private readonly isCloseModalCreateInvoice = new Subject<{ action: number, isActiveModalFile: boolean }>();
  $isCloseModalCreateInvoice = this.isCloseModalCreateInvoice.asObservable();


  private readonly PayorInvoice = new BehaviorSubject<{ action: number, payorInvoice: IPayorInvoice }>
  ({ action: null, payorInvoice: null });
  PayorInvoice$ = this.PayorInvoice.asObservable();


  private readonly documentFile = new Subject<{ action: number, payorInvoice: IPayorInvoice, isActiveModalFile: boolean }>();
  documentFile$ = this.documentFile.asObservable();

  private readonly PayorInvoicearray = new BehaviorSubject<IPayorInvoice[]>([]);
  PayorInvoicearray$ = this.PayorInvoicearray.asObservable();

  private readonly isOpenModalPayorAndProfit =
    new BehaviorSubject<{ action: ActionPayorAndProfitEnum, payorInvoice: IPayorInvoice }>(null);
  isOpenModalPayorAndProfit$ = this.isOpenModalPayorAndProfit.asObservable();

  private readonly isOpenModalSendEmailInvoice = new BehaviorSubject<{
    action: ActionSendEmailInvoiceEnum,
    payorInvoiceIds: number[],
    payorInvoices: IPayorInvoice[],
    isEmailPerAttachment: boolean
  }>
    ({ action: null, payorInvoiceIds: null, payorInvoices: null, isEmailPerAttachment: false });
  isOpenModalSendEmailInvoice$ = this.isOpenModalSendEmailInvoice.asObservable();

  private readonly loadGridComparer = new BehaviorSubject<boolean>(false);
  $loadGridComparer = this.loadGridComparer.asObservable();

  private readonly allProviders = new BehaviorSubject<IProviders[]>([]);
  $allProviders = this.allProviders.asObservable();

  private readonly allPayors = new BehaviorSubject<IPayors[]>([]);
  $allPayors = this.allPayors.asObservable();

  private readonly allStatus = new BehaviorSubject<IStatusInvoices[]>([]);
  $allStatus = this.allStatus.asObservable();

  private readonly saveFiltroInvoice = new BehaviorSubject<IInvoiceFilter>(null);
  $saveFiltroInvoice = this.saveFiltroInvoice.asObservable();

  private filterCompanies = new BehaviorSubject<number[]>(null);
  $filterCompanies = this.filterCompanies.asObservable();

  private filterCompaniesEmail = new BehaviorSubject<number[]>(null);
  $filterCompaniesEmail = this.filterCompaniesEmail.asObservable();

  private closeModalInvoice = new BehaviorSubject<boolean>(false);
  $closeModalInvoice = this.closeModalInvoice.asObservable();

  private closeModalSignature = new BehaviorSubject<boolean>(true);
  $closeModalSignature = this.closeModalSignature.asObservable();

  private onlyNewInvoices = new BehaviorSubject<boolean>(false);
  $onlyNewInvoices = this.onlyNewInvoices.asObservable();

  private closedModalSendInvoice = new BehaviorSubject<boolean>(false);
  $closedModalSendInvoice = this.closedModalSendInvoice.asObservable();

  private typeMultiImport = new BehaviorSubject<number | null>(null);
  $typeMultiImport = this.typeMultiImport.asObservable();

  private suggestedEmails = new BehaviorSubject<string[]>([]);
  suggestedEmails$ = this.suggestedEmails.asObservable();

  private readonly payorProfitCenters = new BehaviorSubject<IProfitAndPayorResponse[]>([]);
  payorProfitCenters$ = this.payorProfitCenters.asObservable();

  constructor(private readonly _http: Http) {
    super();
  }

  getAllProviders() {
    return this._http
      .get(constant.URL_GET_IMPORT_COMPANIES_INVOICES, this.getHeader())
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  getAllPayors() {
    if (this.allPayors && this.allPayors.getValue().length) {
      return this.$allPayors;
    } else {
      return this._http
        .get(constant.URL_GET_PROFITS_AND_PAYOR, this.getHeader())
        .map((response) => response.json())
        .catch((error) => Observable.throw(error.json()));
    }
  }

  getDataGridPayorInvoice(data: any) {
    return this._http
      .post(constant.URL_POST_PAYOR_INVOICES, data, this.getHeader())
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  getDemandLetterByPayorInvoice(payorInvoiceId: number): Observable<Response> {
    return this._http
      .get(
        `${constant.URL_GET_PAYOR_INVOICE_DEMAND_LETTER}/${payorInvoiceId}/DemandLetter`,
        this.getFileHeaders()
      )
      .map((response: Response) => response)
      .catch(error => Observable.throw(error.json()));
  }

  getDemandLettersByPayorInvoices(payorInvoiceIds: number[]): Observable<Response> {
    return this._http
      .post(
        `${constant.URL_GET_PAYOR_INVOICE_DEMAND_LETTER}/DemandLetter/Bulk`,
        payorInvoiceIds,
        this.getFileHeaders()
      )
      .map((response: Response) => response)
      .catch(error => Observable.throw(error.json()));
  }

  searchBypayorInvoiceId(payorInvoiceId: number) {
    return this._http
      .get(
        `${constant.URL_GET_SEARCH_BY__PAYOR_INVOICE_ID}/${payorInvoiceId}`,
        this.getHeader()
      )
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  postPayorInvoice(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_PAYORINVOICES, bodyString, this.headerPost())
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  putPayorInvoice(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_PAYORINVOICES, bodyString, this.headerPost())
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  deletePayorInvoice(payorInvoiceId: number) {
    return this._http
      .delete(
        `${constant.URL_PAYORINVOICES}/${payorInvoiceId}`,
        this.getHeader()
      )
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getStatus() {
    if (this.allStatus && this.allStatus.getValue().length) {
      return this.$allStatus;
    } else {
      return this._http
        .get(constant.URL_GET_STATUS_INVOICES, this.getHeader())
        .map((res) => res.json())
        .do(status => this.allStatus.next(status))
        .catch((error: any) => Observable.throw(error.json()));
    }
  }

  gethistoryinvoice(payorInvoiceId: number) {
    return this._http
      .get(
        `${constant.URL_GET_HISTORY_INVOICES}/${payorInvoiceId}`,
        this.getHeader()
      )
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getDocumentsByPayorInvoice(payorInvoiceId: number, showInactive  = false) {
    return this._http
      .get(
        `${constant.URL_GET_DOCUMENTSBYPAYORINVOICE}/${payorInvoiceId}/${showInactive}`,
        this.getHeader()
      )
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  deleteDocumentsByPayorInvoice(payorinvoicedocumentid: number) {
    return this._http
      .delete(
        `${constant.URL_DELETE_DOCUMENT}/${payorinvoicedocumentid}`,
        this.getHeader()
      )
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getPaymentsByPayorInvoice(payorInvoiceId: number) {
    return this._http
      .get(
        `${constant.URL_GET_PAYMENT}/${payorInvoiceId}`,
        this.getHeader()
      )
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  changeStatusMassive(data: number[], status: number) {
    return this._http
      .post(`${constant.URL_POST_INVOICE_CHANGE_STATUS}/${status}`, data, this.headerPost())
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  sendEmailInvoices(data: IEmailRequest) {
    return this._http
      .post(`${constant.URL_POST_INVOICE_SENT_EMAIL}`, data, this.headerPost())
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  postUpdateStatus() {
    return this._http
      .post(constant.URL_POST_UPDATE_PAYORINVOICE_STATUS, null, this.headerPost())
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  postExternalCompany(payorInvoiceCompany: IPayorInvoiceCompany) {
    return this._http
      .post(constant.URL_POST_EXTERNAL_COMPANY, payorInvoiceCompany, this.headerPost())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  putExternalCompany(payorInvoiceCompany: IPayorInvoiceCompany) {
    return this._http
      .put(constant.URL_PUT_EXTERNAL_COMPANY, payorInvoiceCompany, this.headerPost())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getSmtpSetting() {
    return this._http
      .get(constant.URL_GET_SMTP_SETTING, this.getHeader())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getProfitsAndPayors(description: string) {
    return this._http
      .get(
        `${constant.URL_GET_CONFIGURATION}?description=${description}`,
        this.getHeader()
      )
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }
  putProfitCenterOrPayor(value: IProfitAndPayorResponse) {
    return this._http
      .put(constant.URL_PUT_PROFITS_AND_PAYOR, value, this.headerPost())
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  getSearchPayorInvoiceComparer(companiesFilter) {
    return this._http
      .post(
        `${constant.URL_GET_COMPARER}`,
        companiesFilter,
        this.headerPost()
      )
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }


  getCompaniesExternal() {
    return this.getAllProviders();
  }

  getCompanyExternalById(companyId: number) {
      return this._http
        .get(`${constant.URL_GET_IMPORT_COMPANY_BY_ID}/${companyId}`, this.getHeader())
        .map(response => response.json())
        .catch(error => Observable.throw(error.json()));
  }

  getSignatureByUser() {
      return this._http
        .get(constant.URL_GET_SIGNATURE, this.getHeader())
        .map(response => response.json())
        .catch(error => Observable.throw(error.json()));
  }

  postSignatureByUser(signature: {body: string, disclaimer: string, imageUrl: string}) {
    return this._http
      .post(constant.URL_POST_SIGNATURE, signature, this.headerPost())
      .map((res) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getBillingEmails() {
    return this._http
    .get(`${constant.URL_GET_BILLING_EMAILS}`, this.getHeader())
    .map((res) => res.json())
    .do((emails: string[]) => this.setSuggestedEmails(emails))
    .catch((error: any) => Observable.throw(error.json()));
  }

  showPreviewBodyMessage(data: IEmailRequest) {
    return this._http
      .post(`${constant.URL_POST_INVOICE_PREVIEW_BODY_MESSAGE}`, data, this.headerPost())
      .map(response => response.json())
      .catch(error => Observable.throw(error.json()));
  }

  setLoadGridDocument(loadDocument: boolean) {
    this.loadGridDocument.next(loadDocument);
  }

  setIsCloseModalBatch(action: ActionImportsBatchEnum , isClose: boolean, comparer: boolean = false  ) {
    this.isCloseModalBatch.next({action, isClose, comparer} );
  }

  setIsCloseModalFile(isClose: boolean) {
    this.isCloseModalFile.next(isClose);
  }

  setPayorInvoice(action: number, PayorInvoice: IPayorInvoice) {
    this.PayorInvoice.next({ action: action, payorInvoice: PayorInvoice });
  }

  setDocumentfile(action: number, PayorInvoice: IPayorInvoice, isActiveModalFile: boolean) {
    this.documentFile.next({ action: action, payorInvoice: PayorInvoice, isActiveModalFile });
  }

  setModalCreateInvoice(action: number, isActiveModalFile: boolean) {
    this.isCloseModalCreateInvoice.next({ action: action, isActiveModalFile });
  }

  setPayorInvoiceArray(PayorInvoicearray: IPayorInvoice[]) {
    this.PayorInvoicearray.next(PayorInvoicearray);
  }

  setModalSendEmailInvoice(
    action: ActionSendEmailInvoiceEnum,
    payorInvoiceIds: number[] = null,
    payorInvoices: IPayorInvoice[] = null,
    isEmailPerAttachment: boolean = false
  ) {
    this.isOpenModalSendEmailInvoice.next({
      action,
      payorInvoiceIds,
      payorInvoices,
      isEmailPerAttachment,
    });
  }


  setOpenModalPayorAndProfit(action: ActionPayorAndProfitEnum, payorInvoice: IPayorInvoice = null) {
    this.isOpenModalPayorAndProfit.next({ action, payorInvoice });
  }

  setLoadGridComparer(loadDocument: boolean) {
    this.loadGridComparer.next(loadDocument);
  }

  setSaveFiltroInvoice(saveFiltroInvoice: IInvoiceFilter) {
    this.saveFiltroInvoice.next(saveFiltroInvoice);
  }

  setCompanies(companies: number[] | null) {
    this.filterCompanies.next(companies);
  }

  setAllProviders(providers: IProviders[]) {
    this.allProviders.next(providers);
  }

  setAllProfitsAndPayors(payors: IPayors[]) {
    this.allPayors.next(payors);
  }

  setCompaniesEmail(companies: number[] | null) {
    this.filterCompaniesEmail.next(companies);
  }

  setCloseModalInvoice(close: boolean) {
    this.closeModalInvoice.next(close);
  }

  setCloseModalSignature(close: boolean) {
    this.closeModalSignature.next(close);
  }

  setOnlyNewInvoices(onlyNewInvoices: boolean) {
    this.onlyNewInvoices.next(onlyNewInvoices);
  }

  setClosedModalSendInvoice(closedModalSendInvoice: boolean) {
    this.closedModalSendInvoice.next(closedModalSendInvoice);
  }

  setTypeMultiImport(typeMultiImport: number | null) {
    this.typeMultiImport.next(typeMultiImport);
  }

  setSuggestedEmails(emails: string[]) {
    this.suggestedEmails.next(emails);
  }

  setPayorProfitCenters(profitAndPayorResponse: IProfitAndPayorResponse[]) {
    this.payorProfitCenters.next(profitAndPayorResponse);
  }
}




// WEBPACK FOOTER //
// ./src/app/core/services/invoices-external.service.ts